import { get, isEqual } from 'lodash';
import { useLocation } from 'react-router';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { NamePath } from '~/utils/buildNamePath';
import { isAgent } from '~/utils/getDecodedJwt';
import { useFormItemContext } from './FormItemContext';

export const useSoftDeclineItemcardholder = (name: NamePath | any) => {
  const pathName = useLocation();
  const formItemContext = useFormItemContext();
  const formItemValues = useSelector((state: any) => state?.state?.cardholderData);
  const isOnboardingComleted = formItemContext?.cardholderDetails?.status === 'RECEIVED_CONSENT';
  const cardholderRejectionErrors = formItemContext?.cardholderDetails?.errors;
  const fieldName = cardholderRejectionErrors?.length ? [name].flat().join('.') : '';

  if (isOnboardingComleted && !cardholderRejectionErrors?.length) {
    return {
      cardholderWarningMessage: '',
      isValueUpdated: false,
      cardHolderDisabled: true,
      isItcardholderSoftRejection: !!cardholderRejectionErrors?.length,
    };
  }
  if (!isOnboardingComleted && !cardholderRejectionErrors?.length) {
    return {
      cardholderWarningMessage: '',
      isValueUpdated: false,
      cardHolderDisabled: false,
      isItcardholderSoftRejection: !!cardholderRejectionErrors?.length,
    };
  }

  if (cardholderRejectionErrors?.length) {
    const initialValue = get(formItemContext?.cardholderDetails?.initialCardholderData, [name].flat());
    const updatedValue = get(formItemValues, [name].flat());
    const hasSoftErr = cardholderRejectionErrors?.find((item: any) => {
      const currentStage = pathName?.pathname?.toLowerCase()?.replaceAll('/', '.')?.slice(1);
      const ArrOfValues = Object.values(item?.stepsToFieldsMapping[currentStage] || {})?.flat();
      console.log('ArrOfValues', ArrOfValues);
      console.log('ArrOfValuesfieldName', fieldName);

      return ArrOfValues?.includes(fieldName);
    });
    return {
      cardholderWarningMessage: hasSoftErr?.fieldErrorMessage ?? '',
      isValueUpdated: !isEqual(initialValue, updatedValue),
      cardHolderDisabled: !hasSoftErr,
      isItcardholderSoftRejection: !!cardholderRejectionErrors?.length,
    };
  }

  return {
    // warningMessage,
    // isValueUpdated,
    // withWarning: !!itemWithWarningMessage && !isValueUpdated,
    // disabled: isItemNotEditable,
    // editableBySoftDecline: isItemEditableBySoftDecline,
  };
};
